import { render, staticRenderFns } from "./Contests.vue?vue&type=template&id=c4d37936"
import script from "./Contests.vue?vue&type=script&lang=js"
export * from "./Contests.vue?vue&type=script&lang=js"
import style0 from "./Contests.vue?vue&type=style&index=0&id=c4d37936&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports